var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContactPhone = function SvgIconContactPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 52,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 51.2,
    x: 0.5,
    fill: "#EDECEC",
    rx: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_contact_phone_svg__a",
    width: 25,
    height: 24,
    x: 12,
    y: 14,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M12.5 14h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_contact_phone_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4F4440",
    d: "M31.94 34.5q-2.826 0-5.68-1.315-2.851-1.314-5.247-3.708-2.384-2.395-3.699-5.242Q16 21.386 16 18.56a1.034 1.034 0 0 1 1.05-1.06h3.261q.38 0 .669.247t.368.61l.573 2.943q.06.41-.025.704t-.304.494l-2.31 2.248q.558 1.02 1.275 1.932.716.91 1.55 1.74a17.2 17.2 0 0 0 3.753 2.842l2.244-2.264q.234-.245.568-.342.334-.099.694-.048l2.776.565q.38.1.618.387.24.285.24.65v3.242q0 .45-.305.75t-.755.3"
  }))));
};
export default SvgIconContactPhone;